import { Box } from '@chakra-ui/react';
import AdvanceModule from './home/AdvanceModules';
import Cover from './home/Cover';
import HearFromLeaders from './home/HearFromLeaders';
import Overview from './home/Overview';
import ProgramDetails from './home/ProgramDetails';
import GreenReturnSummitSpeakers from './home/SummitSpeakers';
import KeyDiscussions from './KeyDiscussions';
import GreenReports from './GreenReturnsReports';
const GreenReturnPageLayout = () => (
  <Box pos="relative" overflowX="hidden">
    <Cover />
    <Overview />
    <HearFromLeaders />
    <ProgramDetails />
    <AdvanceModule />
    <KeyDiscussions />
    <GreenReturnSummitSpeakers />
    <GreenReports />
  </Box>
);

export default GreenReturnPageLayout;
